import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-711092f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jobs_content md:!tw-pb-0 md:!tw-box-border" }
const _hoisted_2 = { class: "tw-w-[16px] tw-h-[16px]" }
const _hoisted_3 = ["src"]

import { computed, ref, onBeforeMount, onMounted } from "vue";
import { WORKSTATION } from "@/store/modules/workstation";
import JobsListView from "@/modules/jobs/components/JobsListView.vue";
import EstimateTemplatePage from "@/modules/jobs/pages/EstimateTemplatePage.vue";
import MyJobsListView from "@/modules/jobs/components/MyJobsListView.vue";
import DraftJobListView from "@/modules/jobs/components/DraftJobListView.vue";
import {
  JOBS_ROUTE,
  JOBS_ROUTE_WITH_TYPE,
  JOBS_WITH_SUCCESS_ESTIMATE_SENT_ROUTE,
} from "@/modules/jobs/routes";
import { useRoute } from "vue-router";
import Text from "@/core/components/ui/general/Text.vue";
import CongratsIcon from "@/core/components/icons/CongratsIcon.vue";


import { defineComponent } from "vue";

import RejectedJobListView from "@/modules/jobs/components/RejectedJobListView.vue";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { JOBS_STORE } from "@/store/modules/jobs";
import { UserVerificationStatusEnum } from "@/core/enums/RolesEnum";
import { watch } from "vue";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";

const __default__ = defineComponent({
  name: "JobsPage",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();

const workFlowType = computed(
  () => store.getters[`${JOBS_STORE}/getWorkFlowType`]
);
const tab = ref();
const TEMPLATE = "estimate-template";
const FIND_JOBS = "find-jobs";
const MY_JOBS = "my-jobs";
const DRAFT_JOBS = "draft-jobs";
const REJECTED_JOBS = "rejected-jobs";

const isShowProjectPostSuccessFloater = ref(false);

const jobTabList = [
  {
    name: FIND_JOBS,
    icon: require("../assets/svg/search.svg"),
    label: "Find Jobs",
    component: JobsListView,
  },
  {
    name: MY_JOBS,
    icon: require("../assets/svg/projects.svg"),
    label: "My Jobs",
    component: MyJobsListView,
  },
  {
    name: DRAFT_JOBS,
    icon: require("../assets/svg/Draft.svg"),
    label: "Draft Jobs",
    component: DraftJobListView,
  },
  {
    name: REJECTED_JOBS,
    icon: require("../assets/svg/rejected_jobs.svg"),
    label: "Rejected Jobs",
    component: RejectedJobListView,
  },
  {
    name: TEMPLATE,
    icon: require("../assets/svg/template.svg"),
    label: "template",
    component: EstimateTemplatePage,
  },
];
const getJobRedirectTabName = computed(
  () => store.getters[`${JOBS_STORE}/getJobRedirectTabName`]
);

watch(
  getJobRedirectTabName,
  async (newValue: any, oldValue: any) => {
    tab.value = newValue;
  },
  { immediate: true }
);

const isWorkStationVerified = computed(() => {
  return (
    store.getters[`${WORKSTATION}/activeUserWorkstation`]
      ?.verificationStatus === UserVerificationStatusEnum.VERIFIED
  );
});

const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

const onShowSuccessPostProjectFloater = async () => {
  isShowProjectPostSuccessFloater.value = true;

  await delay(3000);
  isShowProjectPostSuccessFloater.value = false;
};

onBeforeMount(() => {
  if (workFlowType.value) {
    tab.value = DRAFT_JOBS;
  }
  if (route.name === JOBS_ROUTE_WITH_TYPE) {
    if (route.params.type === "Draft Jobs") {
      tab.value = DRAFT_JOBS;
      return;
    }
    if (route.params.type === "Rejected") {
      tab.value = REJECTED_JOBS;
      return;
    }
    tab.value = MY_JOBS;
  }
});

onMounted(async () => {
  console.log(route, "route in jobs");
  console.log(JOBS_WITH_SUCCESS_ESTIMATE_SENT_ROUTE, "route names");
  if (route.name === JOBS_WITH_SUCCESS_ESTIMATE_SENT_ROUTE) {
    onShowSuccessPostProjectFloater();
  }
  // const routeData = router.resolve({
  //   name: "project-details",
  //   params: { refId: ProjectData.value.refId },
  // });
  // window.open(window.location.href, "_blank");
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["success-floater fixed tw-rounded-[6.03px] tw-border-[1.51px] tw-border-solid tw-border-[#24BD63] tw-h-[36px] tw-px-3 tw-flex tw-gap-2 tw-items-center tw-justify-center", { show: isShowProjectPostSuccessFloater.value }])
    }, [
      _createVNode(CongratsIcon),
      _createVNode(Text, null, {
        default: _withCtx(() => [
          _createTextVNode("Congratulations, Your Estimate Was Sent Successfully!")
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_v_tabs, {
      class: "tab-list xxl:!tw-pr-4",
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
      "align-tabs": "center",
      stacked: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jobTabList, (tabItem) => {
          return _createVNode(_component_v_tab, {
            key: tabItem.name,
            value: tabItem.name,
            disabled: !isWorkStationVerified.value && tabItem?.name !== 'find-jobs'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: tabItem.icon,
                  alt: ""
                }, null, 8, _hoisted_3)
              ]),
              _createTextVNode(" " + _toDisplayString(tabItem.label), 1)
            ]),
            _: 2
          }, 1032, ["value", "disabled"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
      touch: false
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jobTabList, (tabValue) => {
          return _createVNode(_component_v_window_item, {
            class: "xxs:!tw-pb-0 md:!tw-pb-0 md:!tw-box-border",
            key: tabValue.name,
            value: tabValue.name
          }, {
            default: _withCtx(() => [
              (tab.value === tabValue.name)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(tabValue.component), { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["value"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})